var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('z-picture',{attrs:{"img":_vm.img,"className":"fulfillment-service"}}),_c('div',{staticClass:"fulfillment-service-text"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }